import React from 'react';

const ArrowIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" width="12" height="12" aria-hidden="true">
    <path d="M5 3l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function Contact() {
  return (
    <section className="cta-section section" id="contact">
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <h2>Have something hard to build?</h2>
        <p>
          Backend systems, AI pipelines or a product that needs a solid technical foundation.
          Let&apos;s talk about what you&apos;re building.
        </p>
        <div className="cta-actions">
          <a
            className="btn btn-accent"
            href="mailto:ivangabrielalabi@gmail.com"
          >
            ivangabrielalabi@gmail.com <ArrowIcon />
          </a>
          <a
            className="btn btn-secondary"
            href="https://www.linkedin.com/in/gabriel-alabi/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </section>
  );
}
